import PropTypes from 'prop-types';

import SpecInput from './SpecInput';
import SpecSlider from './SpecSlider';

function CalculatorInput({ calcInput, onChange }) {
  return calcInput[1].marks ? (
    <SpecSlider key={calcInput[0]} spec={calcInput} onChange={onChange} />
  ) : (
    <SpecInput key={calcInput[0]} spec={calcInput} onChange={onChange} />
  );
}

CalculatorInput.propTypes = {
  calcInput: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default CalculatorInput;
